var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediaTime(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 4C17.1933 4 21 7.84541 21 12.5918C21 17.3381 17.1932 21.1837 12.5 21.1837C7.80675 21.1837 4 17.3381 4 12.5918C4 7.84541 7.80665 4 12.5 4ZM12.5 22.1837C17.7478 22.1837 22 17.8881 22 12.5918C22 7.29539 17.7479 3 12.5 3C7.25209 3 3 7.29539 3 12.5918C3 17.8881 7.25218 22.1837 12.5 22.1837ZM12 8C12 7.72386 12.2239 7.5 12.5 7.5C12.7761 7.5 13 7.72386 13 8V12.8018L15.5452 10.4176C15.759 10.2173 16.0914 10.2173 16.3051 10.4176C16.5395 10.6371 16.5395 11.0092 16.3051 11.2288L13.0534 14.2748C12.9743 14.3489 12.8789 14.3955 12.7793 14.4148C12.6995 14.4686 12.6034 14.5 12.5 14.5C12.2239 14.5 12 14.2761 12 14V8Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaTime);
export default __webpack_public_path__ + "static/media/media-time.ff394e621f7079b5d72fb2a001492469.svg";
export { ForwardRef as ReactComponent };